import { __awaiter, __generator } from "tslib";
import { firstRunVersion } from '@office-start/first-run-types';
import { transformLegacyDataToStateFormat } from '../helpers/transformLegacyDataToStateFormat';
import { getNewUserState } from './getNewUserState';
export function getFirstRunState(identity, officeComponentContext, featureGates) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var inMockMode;
        return __generator(this, function (_b) {
            inMockMode = ((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.firstRunGates) === null || _a === void 0 ? void 0 : _a.firstRunMockEnabled) || false;
            return [2 /*return*/, getNewUserState(identity, officeComponentContext, 'FirstRunState', inMockMode, function (isCompleted) { return ({
                    CompletedFirstRun: isCompleted,
                    Version: firstRunVersion,
                }); }, transformLegacyDataToStateFormat)];
        });
    });
}
//# sourceMappingURL=getFirstRunState.js.map